import { Col, Row, Image, Spin, Button, Space, message, Card } from 'antd';
import Upload from './Upload';
import { useRequest } from 'ahooks';
import { useCompany } from '../../hooks/company';
import { companyMediaController, oSSController } from '../../api';
import { PageHeader } from '@ant-design/pro-components';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';
import ImageList from './ImageList';
import { DeleteOutline } from 'antd-mobile-icons';

const refreshContext = createContext<{ refresh: () => void }>({
  refresh() {},
});

const ImagePreview = ({
  ossKey,
  onClick,
  width,
  process,
}: {
  ossKey: string;
  onClick: () => void;
  width?: number;
  process?: string;
}) => {
  const { id: companyId } = useCompany();

  const { data: url } = useRequest(
    () => {
      return oSSController.getOSSUrl(companyId, ossKey, undefined, process);
    },
    {
      refreshDeps: [companyId, ossKey],
    },
  );

  return <Image src={url} width={width} preview={false} onClick={onClick} />;
};

const DeleteCategory = ({ category }: { category: string }) => {
  const { id: companyId } = useCompany();

  const { refresh } = useContext(refreshContext);

  const { run: deleteCategory, loading } = useRequest(
    () => {
      return companyMediaController.deleteMediaByCategory(companyId, category);
    },
    {
      manual: true,
      onError: (e) => {
        message.error(e.message);
      },
      onSuccess: () => {
        message.success('删除成功');
        refresh();
      },
    },
  );

  return (
    <Button
      onClick={() => deleteCategory()}
      loading={loading}
      icon={<DeleteOutline />}
      danger
      size="small"
    />
  );
};

const DeleteWrapper = ({
  children,
  category,
}: PropsWithChildren<{ category: string }>) => {
  const { hasPermission } = useCompany();

  const canEdit = useMemo(() => {
    return hasPermission('page:media:editor');
  }, [hasPermission]);

  if (!canEdit) {
    return <>{children}</>;
  }

  return (
    <>
      <Space>
        {children}
        <DeleteCategory category={category} />
      </Space>
    </>
  );
};

export default () => {
  const { id: companyId } = useCompany();

  const [currentCategory, setCurrentCategory] = useState<string>();

  const { data, loading, refresh } = useRequest(
    () => {
      return companyMediaController.listCategoryV2(companyId);
    },
    {
      refreshDeps: [companyId],
    },
  );

  return (
    <>
      <PageHeader extra={[<Upload key="upload" />]}>
        <Spin spinning={loading}>
          <Row>
            {data?.map((item) => {
              return (
                <refreshContext.Provider value={{ refresh }}>
                  <Col span={6} key={item.category} style={{ padding: '5px' }}>
                    <Card
                      cover={
                        <ImagePreview
                          ossKey={item.ossKey}
                          onClick={() => {
                            setCurrentCategory(item.category);
                            console.log(item.category);
                          }}
                          process="image/resize,m_fill,w_400,h_400"
                        />
                      }
                    >
                      <Card.Meta title={item.category} />
                    </Card>
                  </Col>
                </refreshContext.Provider>
              );
            })}
          </Row>
          {currentCategory && (
            <ImageList
              companyId={companyId}
              category={currentCategory}
              onClose={() => setCurrentCategory(undefined)}
            />
          )}
        </Spin>
      </PageHeader>
    </>
  );
};
